import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getDownloadSql } from '@/api/bairun/bairunData.js'; //  此处请自行替换地址

import infoList from '@/mixins/infoList';
import * as DateUtil from '@/utils/date';

var _this;

export default {
  name: 'DownloadTaskList',
  components: {},
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return DateUtil.formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getDownloadSql,
      type: '',
      loading: false
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.getTableData();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    // 搜索
    onSubmit: function onSubmit() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    // 下载
    down: function down(row) {
      this.$router.push({
        name: 'DownloadTaskAdd',
        query: {},
        params: {
          meta: {
            title: '添加下载任务'
          },
          gobackParam: {
            isGoback: true
          },
          action: 'add',
          row: row
        }
      });
    }
  }
};